import { AxiosError } from 'axios';
import { useState } from 'react';
import {
  ErrorHttpResponse,
  HttpConfig,
  PaginatedResponse,
} from '../../../models/https';
import { jobApplicationsActions } from '../../../redux/slices/jobApplicationsSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

interface JobApplicationsFilter {
  page?: string;
  perPage?: string;
}

const useGetJobApplications = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();

  const onGetJobApplicationsError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.message ?? 'Something went wrong while fetching job applications'
    );
  };

  const getJobApplications = (filter?: JobApplicationsFilter) => {
    // Extract pagination values from the filter or use defaults
    const page = parseInt(filter?.page ?? '1', 10);
    const perPage = parseInt(filter?.perPage ?? '10', 10);

    // Compute offset (0-indexed) from the page number (which is 1-indexed)
    const offset = page - 1;

    // Construct API URL with pagination parameters
    const urlPath = `jobs-service/applications?offset=${offset}&perPage=${perPage}`;

    const url: HttpConfig = {
      url: urlPath,
      method: 'get',
    };

    const onGetJobApplicationsSuccess = (response: PaginatedResponse) => {
      const {
        totalPages,
        totalElements,
        numberOfElements,
        first,
        last,
        content,
      } = response;

      dispatch(
        jobApplicationsActions.getJobApplications({
          numberOfElements,
          totalElements,
          first,
          last,
          totalPages,
          jobData: Array.isArray(content) ? content : [],
        })
      );
    };

    return request(
      url,
      onGetJobApplicationsSuccess,
      setLoading,
      onGetJobApplicationsError
    );
  };

  return { getJobApplications, loading };
};

export default useGetJobApplications;
